/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { isEmpty } from 'lodash';

import classNames from 'classnames';

import { Button, Loader, Segment } from 'semantic-ui-react';

import ReactHtmlParser from 'react-html-parser';

import { SatCoreRegister, VIEW_SELECTION } from 'sat-core';

import '../css/ProgressView.less';

import { TROPHY } from '../managers/ProgressManager';

import LeaderboardService from '../services/LeaderboardService';

import LeaderBoardModal from '../components/LeaderBoardModal';
import ProgressList from '../components/ProgressList';
import Speedometer from '../components/Speedometer';
import Trophy from '../components/Trophy';

export default
@inject('classroomManager', 'courseManager', 'navigationManager', 'progressManager', 'userManager')
@observer
class ProgressViewOverride extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      openModal: false
    };
  }

  async componentDidMount() {
    const { progressManager, classroomManager, navigationManager, courseManager } = this.props;

    const urlParams = new URLSearchParams(window.location.search);
    const classroomId = urlParams.get('classroomId');

    if (!!classroomId && classroomManager.currentClassroomId === null) {
      classroomManager.setCurrentClassroomId(classroomId);
    }
    navigationManager.setView(VIEW_SELECTION.PROGRESS);
    await courseManager.fetchClassroomCourses(classroomManager.currentClassroomId);

    const classroom = classroomManager.getClassroom(classroomId);

    await progressManager.fetchLeaderboard(classroom.institutionId, courseManager.currentCourseId);
    await progressManager.fetchClassroomProgress(classroomManager.currentClassroomId);

    this.setState({ loading: false });
  }

  clickView = () => {
    this.setState({ openModal: true });
  }

  closeModal = () => {
    this.setState({ openModal: false });
  }

  trophy = (place, label, key) => {
    switch (place) {
      case TROPHY.GOLD: {
        return (
          <div key={key} className='trophy-icon'>
            <Trophy color={TROPHY.GOLD} />
            <div className='trophy-text'>{ReactHtmlParser(label)}</div>
          </div>
        );
      }
      case TROPHY.SILVER: {
        return (
          <div key={key} className='trophy-icon'>
            <Trophy color={TROPHY.SILVER} />
            <div className='trophy-text'>{ReactHtmlParser(label)}</div>
          </div>
        );
      }
      case TROPHY.BRONZE: {
        return (
          <div key={key} className='trophy-icon'>
            <Trophy color={TROPHY.BRONZE} />
            <div className='trophy-text'>{ReactHtmlParser(label)}</div>
          </div>
        );
      }
      default: {
        return (
          <div key={key} className='trophy-icon'>
            <Trophy color={TROPHY.NONE} />
            <div className='trophy-text'>{ReactHtmlParser(label)}</div>
          </div>
        );
      }
    }
  }

  renderTableHeader = (translationKey1, translationKey2) => {
    const { t } = this.props;
    return (
      <div className='table-header'>
        <div className='table-title'>{t(translationKey1)}</div>
        <div className='table-title right'>{t(translationKey2)}</div>
      </div>
    );
  }

  renderTopRankedLeaderboardFaculties = () => {
    const { progressManager } = this.props;

    const { topRankedLeaderboardFaculties } = progressManager;

    return LeaderboardService.renderRankedLeaderboardFaculties(topRankedLeaderboardFaculties, {
      className: 'leaderboard-rank-list top-leaderboard-rank-list',
      shouldShowBadges: true
    });
  }

  renderFocusedRankedLeaderboardFaculties = () => {
    const { progressManager } = this.props;

    const { focusedRankedLeaderboardFaculties } = progressManager;

    return LeaderboardService.renderRankedLeaderboardFaculties(focusedRankedLeaderboardFaculties, {
      className: 'leaderboard-rank-list focused-leaderboard-rank-list',
    });
  }

  render() {
    const { history, progressManager, t } = this.props;

    const { loading, openModal } = this.state;

    const {
      hasClassroomLeaderboardData,
      leaderboardJson,
      speedometerObject,
      topRankedLeaderboardClassroomIndexForCurrentUser
    } = progressManager;

    const { completed, total } = speedometerObject;

    const isEmptyLeaderboard = isEmpty(leaderboardJson);

    let rank, rankTotal, facultyName;

    if (hasClassroomLeaderboardData) {
      const topRankedClassroom = leaderboardJson.classLeaderboard[topRankedLeaderboardClassroomIndexForCurrentUser];

      facultyName = topRankedClassroom?.className;
      rank = topRankedClassroom?.rank || 0;
      rankTotal = leaderboardJson.classLeaderboardTotal || 0;
    } else {
      facultyName = leaderboardJson.institutionName;
      rank = leaderboardJson.institutionRank || 0;
      rankTotal = leaderboardJson.leaderboardTotal || 0;
    }

    return (
      <>
        {!loading ? (
          <div className='progress-view'>
            <div className='top-row'>
              {(rank !== undefined && rank !== null && rank > 0) ? null : (
                <Segment className='title-message'>
                  <div className='title'>
                    {t('leaderboardPositionTitleMessage')}
                  </div>
                </Segment>
              )}
              <Segment className='widget widget-one widget-classroom-progress'>
                <div className='header-bar'>{t('classroomProgress')}</div>
                <div className='title'>{t('lessonProgress')}</div>
                <div className='speed-wrapper'>
                  <Speedometer complete={completed} total={total} />
                  <div className='speed-label'>
                    <div className='speed-text bold'>{`${completed} out of ${total}`}</div>
                    <div className='speed-text'>{t('lessonsComplete')}</div>
                  </div>
                </div>
                <div className='trophy-list'>
                  {progressManager.classroomProgress.map((item) => {
                    return this.trophy(item.trophy, item.courseResourceElementName, item.courseResourceElementId);
                  })}
                </div>
              </Segment>
              <Segment className='widget widget-two widget-leaderboard'>
                <div className='header-bar'>{t('leaderboardHeader')}</div>
                <div className='widget-leaderboard-body-description title'>
                  {t('leaderboardBodyDescription')}
                </div>
                <div className={classNames('widget-leaderboard-body-secondary-description title', {
                  'widget-leaderboard-body-secondary-description-blank': !facultyName
                })}>
                  {!!facultyName && `${facultyName} is ${rank} out of ${rankTotal}`}
                </div>
                <div className='table-wrapper'>
                  {this.renderTableHeader(
                    hasClassroomLeaderboardData || isEmptyLeaderboard ? 'topRankedLeaderboardClassrooms' : 'topRankedLeaderboardSchools',
                    'leaderboardFacultyScore'
                  )}
                  {this.renderTopRankedLeaderboardFaculties()}
                </div>
                <div className='table-wrapper'>
                  {this.renderTableHeader(
                    hasClassroomLeaderboardData || isEmptyLeaderboard ? 'allRankedLeaderboardClassrooms' : 'allRankedLeaderboardSchools',
                    'leaderboardFacultyScore'
                  )}
                  {this.renderFocusedRankedLeaderboardFaculties()}
                </div>
                <div className='widget-leaderboard-button-viewall-wrapper'>
                  <Button className='view-button' onClick={this.clickView}>
                    {t('viewAll')}
                  </Button>
                </div>
              </Segment>
            </div>
            <ProgressList history={history} />
            <LeaderBoardModal closeModal={this.closeModal} openModal={openModal} />
          </div>
        ) : <Loader active />}
      </>
    );
  }
}

SatCoreRegister('ProgressView', ProgressViewOverride);
